import { EuiBasicTableColumn } from '@equipmentshare/ds2'
import cost from './cost'
import description from './description'
import location from './location'
import note from './note'
import partNumber from './partNumber'
import provider from './provider'
import available from './available'
import allocated from './allocated'
import outgoing from './outgoing'
import store from './store'
import rentals from './rentals'
import wac from './wac'
import listPrice from './listPrice'
import msrp from './msrp'

export default function getColumns( hasMultipleStores: boolean, showWac: boolean ): EuiBasicTableColumn<any>[] {
	return [
		...hasMultipleStores ? [ store ] : [],
		partNumber,
		provider,
		description,
		note,
		location,
		available,
		allocated,
		outgoing,
		rentals,
		listPrice,
		msrp,
		...showWac ? [ wac ] : [ cost ],
	]
}
